export enum HubspotFormFieldType {
  TEXT = "text",
  TEXTAREA = "textarea",
  SELECT = "select",
  PHONENUMBER = "phonenumber",
  RADIO = "radio",
}

export interface HubspotFormFieldSelectOptionsType {
  label: string;
  value: string | number;
}
export interface HubSporFormGroupOneFieldModel {
  name: string;
  label: string;
  type: string;
  fieldType: HubspotFormFieldType;
  description: string;
  groupName: string;
  displayOrder: number;
  required: boolean;
  enabled: boolean;
  hidden: boolean;
  defaultValue: string | number | undefined;
  isSmartField: boolean;
  unselectedLabel: string;
  placeholder: string;
  labelHidden: boolean;
  propertyObjectType: string;
  objectTypeId: string;
  options: HubspotFormFieldSelectOptionsType[] | [];
}
export interface HubSporFormFieldGroupModel {
  default: boolean;
  fields: HubSporFormGroupOneFieldModel[];
}
export interface HubSpotFormDataModel {
  id: string;
  guid: string;
  portalId: string;
  submitText: string | null;
  formFieldGroups: HubSporFormFieldGroupModel[];
}
